import { FC } from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import AccountPhotoIcon from '@/components/icons/AccountPhotoIcon';

type Props = {
	url?: string;
	name?: string;
	className?: string;
};

const EAvatar: FC<Props> = ({ url, name, className }) => {
	const initials = name?.split(' ').map((word) => word[0].toUpperCase());

	return (
		<Avatar className={className}>
			<AvatarImage src={url} />
            {
                name 
                    ? (<AvatarFallback >{initials}</AvatarFallback>) 
                    : (<AvatarFallback>{<AccountPhotoIcon className={'w-full h-full'} />}</AvatarFallback>)
            }
		</Avatar>
	);
};

export default EAvatar;
